<div class="page-header">
  
  @if(!isMobile) {
    <h1 class="page-title">Saved Loads</h1>
  } @else {
    <div class="results-count">
      @if (loading) {
        <mat-spinner diameter="20"></mat-spinner>
      } @else {
        Results: 
        <span class="ml-3" [class.no-results]="results.data.length === 0">
          {{ results.data.length }}
        </span>
      }
    </div>
  }

  <div class="header-actions">
    @if(!isMobile) {
      <div class="results-count">
        @if (loading) {
          <mat-spinner diameter="20"></mat-spinner>
        } @else {
          Results: 
          <span class="ml-3" [class.no-results]="results.data.length === 0">
            {{ results.data.length }}
          </span>
        }
      </div>
    }
    <button mat-icon-button class="refresh-button" (click)="getSavedLoads(true)" matTooltip="Refresh" [disabled]="loading">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
</div>

<table mat-table [dataSource]="results" matSort class="results-table">

  <!-- Mobile Column -->
  <ng-container matColumnDef="mobile">
    <th mat-header-cell *matHeaderCellDef></th>

    <td mat-cell *matCellDef="let load">
      <div class="mobile-load-cell">

        @if ((!load.deleted_at && load.visible) || load.is_saved) {
          <button
            mat-icon-button
            class="mobile-save-button"
            (click)="toggleSavedLoad(load); $event.stopPropagation()"
          >
            <mat-icon [class.saved]="load.is_saved">
              {{ load.is_saved ? 'favorite' : 'favorite_border' }}
            </mat-icon>
          </button>
        }

        <div class="mobile-location-row">
          <span class="location-marker filled"></span>

          <div class="location-text">
            {{ load.origin_city | titlecase }}, {{ load.origin_state }}

            @if (load.origin_start_date === load.origin_end_date) {
              <span class="dates">({{ load.origin_start_date | date: 'MM/dd' }})</span>
            } @else {
              <span class="dates">
                ({{ load.origin_start_date | date: 'MM/dd' }} -
                {{ load.origin_end_date | date: 'MM/dd' }})
              </span>
            }
          </div>
        </div>

        <div class="mobile-middle-row">
          <span class="location-connector"></span>

          <span class="middle-text">
            {{ load.distance | number }} mi
          </span>
        </div>

        <div class="mobile-location-row mb-10">
          <span class="location-marker"></span>

          <div class="location-text">
            {{ load.destination_city | titlecase }}, {{ load.destination_state }}

            @if (load.destination_start_date === load.destination_end_date) {
              <span class="dates">({{ load.destination_start_date | date: 'MM/dd' }})</span>
            } @else {
              <span class="dates">
                ({{ load.destination_start_date | date: 'MM/dd' }} -
                {{ load.destination_end_date | date: 'MM/dd' }})
              </span>
            }
          </div>
        </div>

        @if (load.rate) {
          <div class="mobile-details">
            <span class="mobile-rate">
              {{ load.rate | currency:'USD':'symbol':'1.0-0' }}
            </span>

            <span class="mobile-rpm">
              ({{ load.rpm | currency:'USD':'symbol':'1.0-2' }} per mi)
            </span>
          </div>
        }

        <div class="mobile-details">
          {{ load.weight | number }} lbs
          <br />
          {{ getDimensions(load) }}
          <br />
          Well Required: {{ toFeetAndInches(load.well_length) }}
        </div>

        @if (load.deleted_at) {
          <div class="mobile-details">
            <span class="tag red">removed</span>
          </div>
        } @else if (!load.visible) {
          <div class="mobile-details">
            <span class="tag yellow">unposted</span>
          </div>
        } @else {
          <div class="mobile-details">
            Age: {{ formatAge(load.refreshed_since) }}
          </div>
        }

        <div class="mobile-details">
          {{ load.carrier_name }}
        </div>

      </div>
    </td>
  </ng-container>

  <!-- Desktop Columns -->
  <ng-container matColumnDef="is_saved">
    <th mat-header-cell *matHeaderCellDef></th>

    <td mat-cell *matCellDef="let load">

      @if ((!load.deleted_at && load.visible) || load.is_saved) {
        <button
          mat-icon-button
          (click)="toggleSavedLoad(load); $event.stopPropagation()"
        >
          <mat-icon [class.saved]="load.is_saved">
            {{ load.is_saved ? 'favorite' : 'favorite_border' }}
          </mat-icon>
        </button>
      }

    </td>
  </ng-container>

  <ng-container matColumnDef="age">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Age
    </th>
    <td mat-cell *matCellDef="let load">
      @if (load.deleted_at) {
        <span class="tag red">removed</span>
      } @else if (!load.visible) {
        <span class="tag yellow">unposted</span>
      } @else {
        {{ formatAge(load.refreshed_since) }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="pickup_dates">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Pickup
    </th>
    <td mat-cell *matCellDef="let load">
      @if(load.origin_start_date === load.origin_end_date) {
      {{ load.origin_start_date | date: 'MM/dd' }}
      } @else {
      {{ load.origin_start_date | date: 'MM/dd' }} -
      {{ load.origin_end_date | date: 'MM/dd' }}
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="rate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Rate
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.rate | currency:'USD':'symbol':'1.0-0' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="rpm">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      RPM
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.rpm | currency }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Origin
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.origin_city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="origin_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.origin_state }}
    </td>
  </ng-container>

  <ng-container matColumnDef="destination_city">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Destination
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.destination_city }}
    </td>
  </ng-container>

  <ng-container matColumnDef="destination_state">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.destination_state }}
    </td>
  </ng-container>

  <ng-container matColumnDef="weight">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      Weight
    </th>
    <td mat-cell *matCellDef="let load">
      {{ load.weight }}
    </td>
  </ng-container>

  <ng-container matColumnDef="dimensions">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      L x W x H
    </th>
    <td mat-cell *matCellDef="let load">
      {{ getDimensions(load) }}
    </td>
  </ng-container>

  <ng-container matColumnDef="well_required">
    <th mat-header-cell *matHeaderCellDef matTooltip="Well Required" mat-sort-header> 
      Well
    </th>
    <td mat-cell *matCellDef="let load">
      {{ toFeetAndInches(load.well_length) }}
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns" [hidden]="results.data.length === 0"></tr>

  <tr
    mat-row
    *matRowDef="let row; columns: displayedColumns"
    [class.inactive-row]="row.deleted_at || !row.visible"
    [class.clickable-row]="!row.deleted_at && row.visible"
    (click)="!row.deleted_at && row.visible && viewLoadDetails(row)"
  ></tr>

  <tr class="mat-row" *matNoDataRow>
    <td class="no-results-cell" [attr.colspan]="displayedColumns.length">
      <div class="yellow-container">
        You have no saved loads.
      </div>
    </td>
  </tr>
</table>

<br />

<mat-paginator
  [style.display]="results.data.length === 0 ? 'none' : ''"
  [pageSize]="itemsPerPage"
  [pageSizeOptions]="[10, 25, 50, 100]"
  showFirstLastButtons
></mat-paginator>